/*税费相关
i:get || post
h:requestGet ||requestPost
*/
import axios from '../axios'
export default {
    laborCaculator: (data) => {//连续劳务税费试算（计算器）
        return axios.tarzantPost('/account/withdraw/laborCaculator', data);
    },
    resourceLink: () => {// 视频链接
        return axios.tarzantGet('/account/withdraw/resourceLink')
    },
}